import { render, staticRenderFns } from "./EditFaq.vue?vue&type=template&id=6a6496c4"
import script from "./EditFaq.vue?vue&type=script&lang=ts"
export * from "./EditFaq.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports